import classNames from 'classnames'
import { ErrorMessage, useField } from 'formik'

import type { ReactElement } from 'react'

import BasicTextArea from '../../Basic/TextArea'

import '../../input-common.scss'

interface Props {
  className?: string
  disabled?: boolean
  label?: string
  name: string
  placeholder?: string
  required?: boolean
  resizable?: boolean
  rows?: number
}

const TextArea = ({ className, disabled = false, label, name, required, rows, ...props }: Props): ReactElement => {
  /** Local state */

  const [field, { error, touched }] = useField(name)

  /** Render */

  return (
    <div className="input-component textarea-component input-container">
      <div className={classNames('field-container', { erroneous: touched && error })}>
        <BasicTextArea
          className={classNames('input-wrapper', className)}
          label={label}
          required={required}
          {...field}
          {...props}
          disabled={disabled}
          rows={rows}
        />
      </div>
      {touched && error ? <ErrorMessage className="error-message" component="span" name={name} /> : null}
    </div>
  )
}

export default TextArea
